var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.areaname)?_c('h4',[_vm._v(_vm._s(_vm.areaname)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }